import { Badge } from "@/components/ui";
import { deletionCountdown } from "@/lib/format";
import type { Site } from "@/lib/types";

export function SiteStatusBadge({ site }: { site: Site }) {
  if (site.status === "pending_deletion") return <Badge tone="warning">Scheduled for deletion</Badge>;
  if (site.status === "offline")
    return site.offline_reason === "unpublished" ? (
      <Badge>Unpublished</Badge>
    ) : (
      <Badge tone="danger">Offline</Badge>
    );
  if (site.status !== "active") return <Badge>{site.status}</Badge>;
  return site.live_deployment_id ? (
    <Badge tone="success">Live</Badge>
  ) : (
    <Badge tone="warning">Not published</Badge>
  );
}

/** "Deletes in 12 days" beside the status of a site that is scheduled for deletion (nothing otherwise). */
export function DeletionCountdown({ site }: { site: Site }) {
  if (site.status !== "pending_deletion" || !site.purge_at) return null;
  return <Badge tone="warning">{deletionCountdown(site.purge_at)}</Badge>;
}
